export default "dist/images/block-blog-posts-vertical-card.406b764.png";